export default "__VITE_ASSET__DeIixsb0__"